/**
 * 双重预防机制 - 公告栏 API
 * 包括：公告发布、公告查看
 */
import request from "@/utils/enhancedRequest";

// ==================== 公告发布 ====================

/**
 * 获取公告列表（分页）
 * @param {Object} data - 查询参数
 *   - name: 模糊搜索 公告标题 内容
 *   - typeId: 公告类型ID (0宣传公告 1会议公告 2活动公告)
 *   - startTime: 开始时间
 *   - endTime: 结束时间
 *   - pageNo: 页码
 *   - pageSize: 每页数量
 * @returns {Promise}
 */
export function getNoticePage(data) {
  return request({
    url: `/sa/green/pre/announcements/page`,
    method: "post",
    data,
  });
}

/**
 * 获取公告详情
 * @param {String} id - 公告ID
 * @returns {Promise}
 */
export function getNoticeDetail(id) {
  return request({
    url: `/sa/green/pre/announcements/get?id=${id}`,
    method: "get",
  });
}

/**
 * 创建公告
 * @param {Object} data - 公告数据
 *   - id: null (新增传null)
 *   - title: 公告标题
 *   - content: 公告内容
 *   - typeId: 公告类型ID (0宣传公告 1会议公告 2活动公告)
 *   - typeName: 公告类型名称
 *   - file: 附件
 *   - departmentId: 部门ID
 *   - departmentName: 部门名称
 *   - userId: 用户ID
 *   - userName: 用户名称
 * @returns {Promise}
 */
export function createNotice(data) {
  return request({
    url: `/sa/green/pre/announcements/create`,
    method: "post",
    data,
  });
}

/**
 * 更新公告
 * @param {Object} data - 公告数据
 * @returns {Promise}
 */
export function updateNotice(data) {
  return request({
    url: `/sa/green/pre/announcements/update`,
    method: "put",
    data,
  });
}

/**
 * 删除公告
 * @param {String} id - 公告ID
 * @returns {Promise}
 */
export function deleteNotice(id) {
  return request({
    url: `/sa/green/pre/announcements/delete?id=${id}`,
    method: "delete",
  });
}

// ==================== 公告查看 ====================

/**
 * 获取公告查看列表（分页）- 用户查看公告
 * @param {Object} data - 查询参数
 *   - name: 模糊搜索 公告标题 内容
 *   - typeId: 公告类型ID (0宣传公告 1会议公告 2活动公告)
 *   - startTime: 开始时间
 *   - endTime: 结束时间
 *   - pageNo: 页码
 *   - pageSize: 每页数量
 * @returns {Promise}
 */
export function getNoticeReadPage(data) {
  return request({
    url: `/sa/green/pre/announcements/readPage`,
    method: "post",
    data,
  });
}

/**
 * 标记公告为已读
 * @param {String} id - 公告ID
 * @returns {Promise}
 */
export function markNoticeAsRead(id) {
  return request({
    url: `/sa/green/pre/announcements/userRead/${id}`,
    method: "get",
  });
}

/**
 * 获取用户未读公告数
 * @returns {Promise}
 */
export function getUnreadNoticeCount() {
  return request({
    url: `/sa/green/pre/announcements/unreadCount`,
    method: "get",
  });
}



/**
 * 按类型获取公告列表
 * @param {Object} data - 查询参数（包含type: 宣传、会议、活动）
 * @returns {Promise}
 */
export function getNoticeByType(data) {
  return request({
    url: `/sa/safety/notice/byType`,
    method: "post",
    data,
  });
}

/**
 * 获取公告类型列表
 * @returns {Promise}
 */
export function getNoticeTypeList() {
  return request({
    url: `/sa/safety/notice/typeList`,
    method: "get",
  });
}

/**
 * 获取公告的已读未读统计
 * @param {String} noticeId - 公告ID
 * @returns {Promise}
 */
export function getNoticeReadStats(noticeId) {
  return request({
    url: `/sa/safety/notice/readStats/${noticeId}`,
    method: "get",
  });
}

/**
 * 查询单条公告的已读未读详情列表
 * @param {Object} data - 查询参数
 *   - noticeId: 公告ID
 *   - name: 模糊搜索 风险因素 隐患排查清单
 *   - categoryId: 隐患排查分类的ID
 *   - startTime: 开始时间
 *   - endTime: 结束时间
 *   - pageNo: 页码
 *   - pageSize: 每页数量
 * @returns {Promise}
 */
export function getNoticeReadDetailPage(data) {
  return request({
    url: `/sa/green/pre/announcements/readPage`,
    method: "post",
    data,
  });
}

